import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";

const RuleSetListing = () => {
  const [ruleSets, setRuleSets] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [sortConfig, setSortConfig] = useState({ key: "ruleset_name", direction: "asc" });
  const navigate = useNavigate();

  useEffect(() => {
    fetchRuleSets();
  }, []);
 const getSubscriberId = async () => {
  try {
    const token = localStorage.getItem("access_token") || sessionStorage.getItem("access_token") || Cookies.get("access_token");
    if (!token) {
      console.error("❌ No access token found.");
      return null;
    }

    const payload = JSON.parse(atob(token.split(".")[1])); // Decode JWT payload
    const tenantId = payload.tenant_id || payload.subscriber_name; // Extract tenant_id

    if (!tenantId) {
      console.error("❌ tenant_id/subscriber_name missing in token.");
      return null;
    }

    console.log(`✅ Extracted tenant_id: ${tenantId}`);

    // ✅ Fetch subscriber_id from backend synchronously
    const response = await axios.get(`/composite-backend/internal/ui/rules/get-subscriber-id?tenant_id=${tenantId}`);
    return response.data.subscriber_id;
  } catch (error) {
    console.error("❌ Error retrieving subscriber_id:", error);
    return null;
  }
};
 const fetchRuleSets = async () => {
    try {
        const token = localStorage.getItem("access_token");  // ✅ Ensure token is retrieved
        if (!token) {
            console.error("❌ No access token found.");
            return;
        }

        const subscriberId = await getSubscriberId();  // ✅ Ensure subscriber_id is retrieved
        if (!subscriberId) {
            console.error("❌ subscriber_id is missing.");
            return;
        }

        console.log(`✅ Fetching rulesets for subscriber_id: ${subscriberId}`);

        // ✅ Corrected string interpolation in API URL
        const response = await axios.get(`/composite-backend/internal/ui/rules/list-ruleset?subscriber_id=${subscriberId}`, {
            withCredentials: true,  // ✅ Ensures cookies are sent
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,  // ✅ Send token properly
            }
        });

        setRuleSets(response.data);
    } catch (error) {
        console.error("❌ Error fetching rule sets:", error);
    }
};



  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleCreateNew = () => {
    navigate("/manage-rulesets", { state: { isNew: true } });
  };

  const handleEdit = (ruleSet) => {
    if (ruleSet.status !== "Draft") {
      alert("Only Draft rulesets can be edited.");
      return;
    }
    navigate(`/manage-rulesets/${ruleSet.ruleset_name}`);
  };

  const handleMoveToUnderReview = async (ruleSetId) => {
    try {
      const response = await axios.post("/composite-backend/internal/ui/rules/update-ruleset-status", {
        ruleset_id: ruleSetId,
        status: "Under Review",
      });
      alert("Ruleset moved to Under Review successfully!");
      fetchRuleSets();
    } catch (error) {
      console.error("Error response from backend:", error.response?.data || error.message);
      alert("Failed to move ruleset to Under Review. Please try again.");
    }
  };

  const handleSort = (key) => {
    setSortConfig((prevSortConfig) => ({
      key,
      direction: prevSortConfig.key === key && prevSortConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const getSortedRuleSets = (data) => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      // Handle timestamp columns
      if (sortConfig.key === "created_date") {
        return sortConfig.direction === "asc"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }

      // Handle string sorting
      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      // Handle other types (e.g., numeric)
      return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
    });
  };

  const filteredRuleSets = getSortedRuleSets(
    ruleSets
      .filter((ruleSet) =>
        ruleSet.ruleset_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .filter((ruleSet) =>
        statusFilter === "All" ? true : ruleSet.status === statusFilter
      )
  );

  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#007BFF",
          padding: "16px",
          color: "#FFF",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src="/assets/b4d48a3e-5b5a-4392-ab30-df41c0a4471a.jpg"
            alt="Idenza Logo"
            style={{ width: "50px", marginRight: "10px" }}
          />
          <h1 style={{ margin: "0" }}>Idenza</h1>
        </div>
        <h2 style={{ textAlign: "center", flexGrow: 1 }}>Rule Sets</h2>
      </div>

      {/* Top Bar */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px",
        }}
      >
        <input
          type="text"
          placeholder="Search rule sets..."
          value={searchTerm}
          onChange={handleSearchChange}
          style={{
            padding: "8px",
            width: "60%",
            borderRadius: "4px",
            border: "1px solid #D1D5DB",
          }}
        />
        <select
          value={statusFilter}
          onChange={handleStatusFilterChange}
          style={{
            padding: "8px",
            marginLeft: "16px",
            borderRadius: "4px",
            border: "1px solid #D1D5DB",
          }}
        >
          <option value="All">All</option>
          <option value="Draft">Draft</option>
          <option value="Under Review">Under Review</option>
          <option value="Approved">Approved</option>
        </select>
        <button
          onClick={handleCreateNew}
          style={{
            backgroundColor: "#007BFF",
            color: "#FFF",
            padding: "8px 16px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            marginLeft: "16px",
          }}
        >
          Manage RuleSets
        </button>
      </div>

      {/* RuleSet Table */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          margin: "16px 0",
          fontSize: "16px",
          backgroundColor: "#FFF",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#F3F4F6" }}>
            <th
              onClick={() => handleSort("ruleset_name")}
              style={{
                cursor: "pointer",
                textAlign: "left",
                padding: "8px",
                borderBottom: "1px solid #E5E7EB",
              }}
            >
              Name {sortConfig.key === "ruleset_name" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
            </th>
            <th
              onClick={() => handleSort("description")}
              style={{
                cursor: "pointer",
                textAlign: "left",
                padding: "8px",
                borderBottom: "1px solid #E5E7EB",
              }}
            >
              Description {sortConfig.key === "description" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
            </th>
            <th
              onClick={() => handleSort("status")}
              style={{
                cursor: "pointer",
                textAlign: "left",
                padding: "8px",
                borderBottom: "1px solid #E5E7EB",
              }}
            >
              Status {sortConfig.key === "status" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
            </th>
            <th
              onClick={() => handleSort("created_date")}
              style={{
                cursor: "pointer",
                textAlign: "left",
                padding: "8px",
                borderBottom: "1px solid #E5E7EB",
              }}
            >
              Created Date (UTC) {sortConfig.key === "created_date" ? (sortConfig.direction === "asc" ? "▲" : "▼") : ""}
            </th>
            <th style={{ textAlign: "left", padding: "8px", borderBottom: "1px solid #E5E7EB" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredRuleSets.length > 0 ? (
            filteredRuleSets.map((ruleSet) => (
              <tr key={ruleSet.ruleset_name} style={{ borderBottom: "1px solid #E5E7EB" }}>
                <td style={{ padding: "8px" }}>{ruleSet.ruleset_name}</td>
                <td style={{ padding: "8px" }}>{ruleSet.description}</td>
                <td>
                            <span className={`badge rounded-pill d-flex align-items-center gap-1
              ${ruleSet.status === 'Draft' ? 'bg-secondary' :
                ruleSet.status === 'Under Review' ? 'bg-warning text-dark' :
                ruleSet.status === 'Approved' ? 'bg-success' :
                'bg-light text-dark'}`}>
              {ruleSet.status === 'Approved' && '✅'}
              {ruleSet.status === 'Under Review' && '🕒'}
              {ruleSet.status === 'Draft' && '📄'}
              {ruleSet.status}
            </span>

              </td>

                <td style={{ padding: "8px" }}>{new Date(ruleSet.created_date).toISOString()}</td>
                <td style={{ padding: "8px" }}>
  <div className="d-flex gap-2 flex-wrap">
    {ruleSet.status === "Draft" && (
      <button
        className="btn btn-sm btn-primary"
        onClick={() => handleMoveToUnderReview(ruleSet.id)}
      >
        Submit for Review
      </button>
    )}
    <button
      onClick={() => handleEdit(ruleSet)}
      disabled={ruleSet.status !== "Draft"}
      className={`btn btn-sm ${
        ruleSet.status === "Draft" ? "btn-success" : "btn-secondary disabled"
      }`}
    >
      Edit
    </button>
  </div>
</td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "16px" }}>
                No Rule Sets Found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Footer Section */}
      <div
        style={{
          backgroundColor: "#007BFF",
          color: "#FFF",
          textAlign: "center",
          padding: "16px",
          marginTop: "16px",
        }}
      >
        <p>Manage Rule Sets © 2025</p>
      </div>
    </div>
  );
};

export default RuleSetListing;

